// HERZ theme — minimal client behaviour. Calm by design.
(function () {
  'use strict';

  // Product detail: finish selector + tabs (progressive enhancement)
  function initPdp() {
    var finishes = document.querySelectorAll('[data-finish]');
    finishes.forEach(function (el) {
      el.addEventListener('click', function () {
        finishes.forEach(function (f) { f.classList.remove('tag--active'); });
        el.classList.add('tag--active');
        var url = el.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });

    var tabs = document.querySelectorAll('[data-tab]');
    var panels = document.querySelectorAll('[data-tab-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.toggle('tab--active', t === tab); });
        panels.forEach(function (p) {
          p.style.display = p.getAttribute('data-tab-panel') === key ? 'block' : 'none';
        });
      });
    });
  }

  // Collection: filter chips
  function initFilters() {
    var chips = document.querySelectorAll('[data-filter]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var url = chip.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  }

  // In-page anchor links (e.g. hero "Explore" CTA scrolling to the section below):
  // handled manually rather than relying on native hash-scroll, since a same-tick
  // scrollIntoView call can get cancelled by the browser's own post-click handling
  // (focus/pointer settling). Deferring one frame avoids that race.
  function initAnchorScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;
      var id = link.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
      if (history.pushState) history.pushState(null, '', '#' + id);
    });
  }

  // ---- Announcement bar: compact language/currency toggle ----
  function initLocalizationToggle() {
    var widget = document.querySelector('[data-loc-widget]');
    if (!widget) return;
    var toggle = widget.querySelector('[data-loc-toggle]');
    var panel = widget.querySelector('[data-loc-panel]');
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.hidden) open(); else close();
    });

    document.addEventListener('click', function (e) {
      if (!panel.hidden && !widget.contains(e.target)) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) close();
    });
  }

  // ---- PDP size guide lightbox ----
  function initSizeGuideLightbox() {
    var lightbox = document.querySelector('[data-size-guide-lightbox]');
    if (!lightbox) return;

    function open() {
      lightbox.classList.add('pdp__size-guide-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-guide-lightbox-locked');
    }
    function close() {
      lightbox.classList.remove('pdp__size-guide-lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-guide-lightbox-locked');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) {
        e.preventDefault();
        open();
        return;
      }
      if (e.target.closest('[data-size-guide-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('pdp__size-guide-lightbox--open')) close();
    });
  }

  // ---- PDP mobile gallery: swipeable carousel + dot indicators ----
  function initPdpGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    var dotsWrap = document.querySelector('[data-pdp-gallery-dots]');
    if (!gallery || !dotsWrap) return;

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-pdp-gallery-dot]'));
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.pdp__hero, .pdp__thumb'));

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('pdp__gallery-dot--active', i === index); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-pdp-gallery-dot'), 10);
        var slide = slides[idx];
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var width = gallery.clientWidth || 1;
        var index = Math.round(gallery.scrollLeft / width);
        setActive(index);
        ticking = false;
      });
    });
  }

  // ---- Product card galleries: swipeable image carousel + dots, one per card.
  // On hover-capable pointers (desktop), hovering a card also scrolls its gallery
  // to the second image and back — reuses the same scrollTo/scroll-sync plumbing
  // as touch swipe and the dot buttons, so the active dot stays correct either way.
  function initCardGalleries() {
    var galleries = Array.prototype.slice.call(document.querySelectorAll('[data-card-gallery]'));
    var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    galleries.forEach(function (gallery) {
      var media = gallery.closest('.product-card__media');
      var dotsWrap = media ? media.querySelector('[data-card-dots]') : null;
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product-card__slide'));
      if (!dotsWrap) return;

      var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-card-dot]'));
      var arrowPrev = media.querySelector('[data-card-arrow="prev"]');
      var arrowNext = media.querySelector('[data-card-arrow="next"]');
      // Tracks the intended slide index directly, rather than deriving it from
      // gallery.scrollLeft — scrollTo({behavior:'smooth'}) is async, so reading
      // scrollLeft again right after a click (e.g. two fast arrow clicks) would
      // see a stale, still-animating position and both clicks would land on the
      // same slide instead of stepping forward twice.
      var targetIndex = 0;

      function setActive(index) {
        dots.forEach(function (d, i) { d.classList.toggle('product-card__dot--active', i === index); });
        if (arrowPrev) arrowPrev.disabled = index === 0;
        if (arrowNext) arrowNext.disabled = index === slides.length - 1;
      }

      function goToIndex(index) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        targetIndex = index;
        var slide = slides[index];
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToIndex(parseInt(dot.getAttribute('data-card-dot'), 10));
        });
      });

      // Arrows step sequentially through every image (3rd, 4th, etc.) — the dots
      // already let you jump to a specific index, but they're small targets, so
      // this covers "just go to the next one" without needing precision aim.
      if (arrowPrev) {
        arrowPrev.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToIndex(targetIndex - 1);
        });
      }
      if (arrowNext) {
        arrowNext.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goToIndex(targetIndex + 1);
        });
      }

      var ticking = false;
      gallery.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var width = gallery.clientWidth || 1;
          var index = Math.round(gallery.scrollLeft / width);
          targetIndex = index;
          setActive(index);
          ticking = false;
        });
      });

      setActive(0);

      if (supportsHover && slides.length > 1) {
        var card = gallery.closest('.product-card');
        if (card) {
          card.addEventListener('mouseenter', function () {
            targetIndex = 1;
            gallery.scrollTo({ left: slides[1].offsetLeft, behavior: 'smooth' });
          });
          card.addEventListener('mouseleave', function () {
            targetIndex = 0;
            gallery.scrollTo({ left: slides[0].offsetLeft, behavior: 'smooth' });
          });
        }
      }
    });
  }

  // ---- PDP price sync with the Kaching Bundles tier widget.
  // Kaching's own app-block script renders the tier radios/prices inside
  // .kaching-bundles__block — it isn't theme code, so we can't edit its logic,
  // and it pre-checks its "2 Bracelets — Save 15%" tier by default on every page
  // load, not the single-item tier. That wrong default drives Kaching's own
  // "Add to bag" button price too (confirmed: manually selecting the 1-item tier
  // updates both Kaching's button and this sync at once), so the fix is to
  // correct the actual selected tier once, right when the widget appears — not
  // just to patch our own price display around it.
  //
  // Kaching hydrates its widget asynchronously, well after DOMContentLoaded, so
  // .kaching-bundles__block doesn't exist yet when this runs — a body-level
  // observer waits for it to actually appear before attaching anything.
  function initBundlePriceSync() {
    var stickyPrice = document.querySelector('[data-pdp-sticky-price]');
    var mainSale = document.querySelector('.pdp__price-sale');
    var mainCompare = document.querySelector('.pdp__price-compare');
    var mainPrice = document.querySelector('.pdp__price');
    var saveBadge = document.querySelector('.pdp__save-badge');
    if (!stickyPrice && !mainPrice) return;

    var attachedBlock = null;

    // Shop's money format here is always "€X.XXX,XX" (comma decimal, dot
    // thousands) — confirmed the same across all three storefront locales —
    // so this doesn't need to handle other formats.
    function parseMoney(text) {
      var cleaned = text.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
      return parseFloat(cleaned);
    }

    function applyPrice(saleText, compareText) {
      if (stickyPrice) stickyPrice.textContent = saleText;
      if (mainSale) {
        mainSale.textContent = saleText;
        if (mainCompare && compareText) mainCompare.textContent = compareText;
      } else if (mainPrice) {
        Array.prototype.forEach.call(mainPrice.childNodes, function (node) {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
            node.textContent = saleText;
          }
        });
      }

      // The save-percentage badge was computed server-side from the single-item
      // price/compare-at and never updated with the tier — same bug as the price
      // fields above. Swap only the digits so the translated "Save X%" / "Ahorra
      // X%" label stays correct in whichever locale is active.
      if (saveBadge && compareText) {
        var sale = parseMoney(saleText);
        var compare = parseMoney(compareText);
        if (!isNaN(sale) && !isNaN(compare) && compare > 0) {
          var pct = Math.round(((compare - sale) / compare) * 100);
          saveBadge.textContent = saveBadge.textContent.replace(/\d+/, String(pct));
        }
      }
    }

    function syncFromCheckedBar(block) {
      var checked = block.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
      if (!checked) return;
      var bar = checked.closest('.kaching-bundles__bar');
      if (!bar) return;
      var priceEl = bar.querySelector('.kaching-bundles__bar-price');
      var fullPriceEl = bar.querySelector('.kaching-bundles__bar-full-price');
      if (priceEl) applyPrice(priceEl.textContent.trim(), fullPriceEl ? fullPriceEl.textContent.trim() : null);
    }

    function attachToBlock(block) {
      if (attachedBlock === block) return;
      attachedBlock = block;

      block.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) syncFromCheckedBar(block);
      });

      // Kaching can also update the selected bar's own price without firing a
      // radio change (e.g. swapping the bracelet via "Choose another bracelet"),
      // so this also watches the block for content changes as a fallback.
      var innerObserver = new MutationObserver(function () { syncFromCheckedBar(block); });
      innerObserver.observe(block, { childList: true, subtree: true, characterData: true });

      // Correct Kaching's wrong default tier selection with a real click (not
      // just setting .checked) so Kaching's own internal state — and therefore
      // its Add to cart button text — updates too, not just our own price
      // fields. The first bar is always the single-item tier ("1 Bracelet").
      var firstBar = block.querySelector('.kaching-bundles__bar');
      var firstRadio = firstBar ? firstBar.querySelector('input[type="radio"]') : null;
      if (firstRadio && !firstRadio.checked) {
        firstRadio.click();
      } else {
        syncFromCheckedBar(block);
      }
    }

    var existing = document.querySelector('.kaching-bundles__block');
    if (existing) attachToBlock(existing);

    var bodyObserver = new MutationObserver(function () {
      var block = document.querySelector('.kaching-bundles__block');
      if (block && block !== attachedBlock) attachToBlock(block);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // ---- Sticky add-to-cart bar: for bundle products (Kaching widget present),
  // scroll up to "Build your set" instead of adding directly — the shopper needs
  // to choose which bracelets go into a multi-item tier via the widget's own
  // "Choose another bracelet" controls first. Kaching intercepts the theme's real
  // add-to-cart form, so submitting straight from the sticky bar was silently
  // adding whichever tier happened to be selected without giving the shopper that
  // choice. Simple (non-bundle) products have no widget on the page, so the
  // sticky button keeps submitting normally for those.
  function initStickyAddToCart() {
    var stickyBar = document.querySelector('[data-pdp-sticky-bar]');
    if (!stickyBar) return;
    var stickyBtn = stickyBar.querySelector('button[type="submit"]');
    if (!stickyBtn) return;

    stickyBtn.addEventListener('click', function (e) {
      var bundleBlock = document.querySelector('.kaching-bundles__block');
      if (!bundleBlock) return;
      e.preventDefault();
      bundleBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // ---- Nav drawer: mobile menu ----
  var navDrawer = document.getElementById('NavDrawer');

  function openNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.add('nav-drawer--open');
    navDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-drawer-locked');
  }

  function closeNavDrawer() {
    if (!navDrawer) return;
    navDrawer.classList.remove('nav-drawer--open');
    navDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-drawer-locked');
  }

  function initNavDrawer() {
    if (!navDrawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-nav-drawer-open]')) {
        e.preventDefault();
        openNavDrawer();
        return;
      }
      if (e.target.closest('[data-nav-drawer-close]')) {
        closeNavDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navDrawer.classList.contains('nav-drawer--open')) closeNavDrawer();
    });
  }

  // ---- Cart: AJAX add-to-cart + header count badge only.
  // The "Essential Cart Drawer" app owns the actual drawer UI (upsells, discount
  // codes, free-shipping bar) — it auto-intercepts both /cart/add(.js) requests
  // and plain links to /cart, so this theme only needs to keep the underlying
  // fetch calls working (for quick-add buttons and the PDP form) and keep the
  // header's own cart-count badge in sync. No drawer markup or rendering here.
  var cartState = null;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function fetchCart() {
    var cartUrl = (window.themeRoutes && window.themeRoutes.cart) || '/cart';
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      cartState = cart;
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  function addToCart(body, isFormData) {
    var url = (window.themeRoutes && window.themeRoutes.cartAdd) || '/cart/add.js';
    return fetch(url, {
      method: 'POST',
      headers: isFormData ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      });
    });
  }

  function initCart() {
    refreshCart();

    document.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add]');
      if (!addBtn) return;
      e.preventDefault();
      var variantId = addBtn.getAttribute('data-add');
      addBtn.disabled = true;
      addToCart(JSON.stringify({ id: variantId, quantity: 1 }))
        .then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { addBtn.disabled = false; });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;
      addToCart(new FormData(form), true)
        .then(function () { return refreshCart(); })
        .catch(function () {})
        .then(function () { if (submitBtn) submitBtn.disabled = false; });
    });
  }

  // ---- Video gallery: pause clips off-viewport, respect reduced motion ----
  function initInViewVideos() {
    var videos = document.querySelectorAll('.video-gallery__video');
    if (!videos.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      videos.forEach(function (video) {
        video.removeAttribute('autoplay');
        video.pause();
      });
      return;
    }
    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.play().catch(function () {});
          else entry.target.pause();
        });
      },
      { threshold: 0.25 }
    );
    videos.forEach(function (video) { observer.observe(video); });
  }

  // ---- Video gallery: tap-to-unmute (autoplay clips start muted by browser requirement) ----
  function initVideoGalleryMute() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-video-mute]');
      if (!btn) return;
      var item = btn.closest('.video-gallery__item');
      var video = item ? item.querySelector('.video-gallery__video') : null;
      if (!video) return;

      video.muted = !video.muted;

      var mutedIcon = btn.querySelector('.video-gallery__mute-icon--muted');
      var unmutedIcon = btn.querySelector('.video-gallery__mute-icon--unmuted');
      if (mutedIcon) mutedIcon.hidden = !video.muted;
      if (unmutedIcon) unmutedIcon.hidden = video.muted;
      btn.setAttribute('aria-label', video.muted ? 'Activar sonido' : 'Silenciar');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPdp();
    initFilters();
    initAnchorScroll();
    initLocalizationToggle();
    initSizeGuideLightbox();
    initPdpGallery();
    initCardGalleries();
    initBundlePriceSync();
    initStickyAddToCart();
    initInViewVideos();
    initVideoGalleryMute();
    initNavDrawer();
    initCart();
  });
})();
